import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import React, { useState } from 'react';

import Chip from 'root/client/components/chip/chip';
import ContentContainer from 'root/client/components/content-container/content-container';
import ElementInterpolator from 'root/client/components/element-interpolator/element-interpolator';
import LocationSearch from 'root/client/components/location-search/location-search';
import ClubLink from 'root/client/components/club-link/club-link';
import SalesLayout from 'root/client/components/sales-layout/sales-layout';

import type {
  DropInSelectClub as Props,
  Region,
} from './drop-in-select-club.types';

const DropInSelectClub: React.FC<Props> = ({
  clubCountTemplate,
  defaultSelectedRegion,
  filterHeaderTitle,
  layout,
  locationSearch,
  regionFilterLabel,
  regions,
}) => {
  const [selectedRegion, setSelectedRegion] = useState<Region>(
    defaultSelectedRegion,
  );

  return (
    <SalesLayout {...layout}>
      <ContentContainer width={ContentContainer.widths.Narrow}>
        <div className="drop-in-select-club">
          <LocationSearch {...locationSearch} />
          <div className="drop-in-select-club__filters-section">
            <div className="drop-in-select-club__filters-section-header">
              <Text size={Text.sizes.small} theme={Text.themes.emphasis}>
                {filterHeaderTitle}
              </Text>
              <Text
                className="drop-in-select-club__club-count"
                size={Text.sizes.small}
              >
                <ElementInterpolator
                  template={clubCountTemplate}
                  elements={{
                    clubCount: (
                      <Text size={Text.sizes.small}>
                        {defaultSelectedRegion.clubs.length.toString()}
                      </Text>
                    ),
                  }}
                />
              </Text>
            </div>
            <div
              aria-label={regionFilterLabel}
              className="drop-in-select-club__filters"
              role="group"
            >
              {regions.map(region => (
                <Chip
                  key={region.name}
                  label={region.name}
                  onClick={() => setSelectedRegion(region)}
                  selected={selectedRegion.name === region.name}
                />
              ))}
            </div>
            <div className="drop-in-select-club__filtered-club-count">
              <Text size={Text.sizes.small} theme={Text.themes.emphasis}>
                {selectedRegion.name}
              </Text>
              <Text
                className="drop-in-select-club__club-count"
                size={Text.sizes.small}
              >
                <ElementInterpolator
                  template={clubCountTemplate}
                  elements={{
                    clubCount: (
                      <Text size={Text.sizes.small}>
                        {selectedRegion.clubs.length.toString()}
                      </Text>
                    ),
                  }}
                />
              </Text>
            </div>
          </div>

          <div className="drop-in-select-club__clubs">
            {selectedRegion.clubs.map(club => (
              <ClubLink {...club} key={club.href} />
            ))}
          </div>
        </div>
      </ContentContainer>
    </SalesLayout>
  );
};

export default DropInSelectClub;
